export default "__VITE_ASSET__Bohez0hp__"